import { uploadAccreditationDateAction } from "../../../redux/actions/GlobalAction";

export const uploadDateHandler = async (docType, date, dispatch,source) => {
  const formData = new FormData();
  formData.append("Image", "");
  formData.append("DocType", docType);
  formData.append("Validity", date);
  if(source === "WhatsApp" || source === "Email"){
    formData.append("Source", source);
  }
  await dispatch(uploadAccreditationDateAction(formData));
};

export const saveData = {
  validityNABL: null,
  validityNABH: null,
  validityISO: null,
  validityCAP: null,
};
